import React from 'react';
import { Link } from 'react-router-dom';
import { useSubscription } from '../context/SubscriptionContext';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';

export default function FeatureGate({ feature, children, inline = false }) {
  const { hasFeature, subscription, loading } = useSubscription();
  const { user } = useAuth();
  const { t } = useLanguage();

  if (user?.role === 'superadmin') return <>{children}</>;
  if (loading) return (
    <div className="flex items-center justify-center h-32 text-gray-400">
      <span className="animate-spin mr-2 inline-block" aria-hidden="true">⏳</span> {t('loading') || 'Yükleniyor...'}
    </div>
  );

  if (hasFeature(feature)) return <>{children}</>;

  const featureNames = {
    kitchen_display:    t('featureNameKitchenDisplay')   || 'Mutfak Ekranı',
    stock_management:   t('featureNameStockManagement')  || 'Stok Yönetimi',
    recipe_system:      t('featureNameRecipeSystem')     || 'Reçete Sistemi',
    waiter_management:  t('featureNameWaiterManagement') || 'Garson Yönetimi',
    advanced_analytics: t('featureNameAdvancedAnalytics')|| 'Gelişmiş Analitik',
    qr_menu:            t('featureNameQrMenu')           || 'QR Menü',
  };
  const featureLabel = featureNames[feature] || feature;
  const noSubscription = !subscription;

  if (inline) {
    return (
      <div className="flex items-center gap-2 text-amber-600 dark:text-amber-400">
        <span aria-hidden="true">🔒</span>
        <span className="text-sm font-medium">{featureLabel} — {t('featureGateInlineUpgrade') || 'Planı Yükselt'}</span>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] p-8">
      <div className="max-w-sm w-full bg-white dark:bg-gray-800 rounded-3xl border border-amber-200 dark:border-amber-800 shadow-lg p-8 text-center">
        <div className="w-20 h-20 bg-amber-100 dark:bg-amber-900/30 rounded-full flex items-center justify-center mx-auto mb-5">
          <span className="text-4xl" aria-hidden="true">🔒</span>
        </div>
        <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-2">{featureLabel}</h2>
        <p className="text-gray-500 dark:text-gray-400 text-sm mb-6">
          {noSubscription
            ? (t('featureGateNoSubDesc') || 'Bu özelliği kullanmak için bir plan seçmeniz gerekiyor.')
            : (t('featureGateUpgradeDesc') || 'Bu özellik mevcut planınıza dahil değildir. Daha fazlası için planınızı yükseltin.')}
        </p>
        <div className="space-y-2">
          <Link
            to="/my-subscription"
            className="block w-full bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white font-semibold py-3 rounded-xl transition-all"
          >
            {noSubscription
              ? <><span aria-hidden="true">🚀</span> {t('featureGateChoosePlan') || 'Plan Seç'}</>
              : <><span aria-hidden="true">⬆️</span> {t('featureGateUpgradePlan') || 'Planı Yükselt'}</>}
          </Link>
          <Link
            to="/pricing"
            className="block w-full bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 font-medium py-3 rounded-xl transition-all hover:bg-gray-200 dark:hover:bg-gray-600"
          >
            {t('featureGateSeeAllPlans') || 'Tüm Planları Gör'}
          </Link>
        </div>
      </div>
    </div>
  );
}
